const CP_RE = /^\d{5}$/;

const CAMPOS_DOMICILIO = [
  "pais",
  "estado_provincia",
  "ciudad",
  "colonia",
  "calle",
  "numero_exterior",
  "numero_interior",
  "codigo_postal",
] as const;

const REQUERIDOS_NACIONAL = [
  ["colonia", "la colonia"],
  ["calle", "la calle"],
  ["numero_exterior", "el número exterior"],
  ["codigo_postal", "el código postal"],
] as const;

const REQUERIDOS_EXTRANJERO = [
  ["pais", "el país"],
  ["estado_provincia", "el estado/provincia"],
  ["ciudad", "la ciudad/población"],
  ...REQUERIDOS_NACIONAL,
] as const;

type CampoGetter = (k: string) => string;
type TipoDomicilio = "nacional" | "extranjero";

function limpio(v: string): string | null {
  const s = v.trim();
  return s === "" ? null : s;
}

function tipoDomicilio(campo: CampoGetter): TipoDomicilio {
  return campo("dom_tipo") === "extranjero" ? "extranjero" : "nacional";
}

function dom(campo: CampoGetter, k: string): string | null {
  return limpio(campo(`dom_${k}`));
}

function hayDomicilio(campo: CampoGetter): boolean {
  return CAMPOS_DOMICILIO.some((k) => dom(campo, k) !== null);
}

/**
 * Errores del domicilio, indexados por la clave del campo del formulario
 * (`dom_codigo_postal`, `dom_colonia`, …) para poder pintarlos pegados al input
 * que falla. Devuelve `{}` cuando no hay domicilio o está completo.
 */
export function erroresDomicilioPersona(campo: CampoGetter): Record<string, string> {
  const errores: Record<string, string> = {};
  const cp = dom(campo, "codigo_postal");
  if (cp && !CP_RE.test(cp)) errores.dom_codigo_postal = "Código postal del domicilio: 5 dígitos. Ej: 97000";
  if (!hayDomicilio(campo)) return errores;

  const requeridos = tipoDomicilio(campo) === "extranjero" ? REQUERIDOS_EXTRANJERO : REQUERIDOS_NACIONAL;
  for (const [k, etiqueta] of requeridos) {
    if (!dom(campo, k)) errores[`dom_${k}`] = `Falta ${etiqueta} del domicilio.`;
  }
  return errores;
}

export function armarDomicilioPersona(campo: CampoGetter): Record<string, string> {
  if (!hayDomicilio(campo)) return {};
  const domicilio: Record<string, string> = {};
  const tipo = tipoDomicilio(campo);
  if (tipo === "extranjero") domicilio.tipo = "extranjero";
  for (const k of CAMPOS_DOMICILIO) {
    const v = dom(campo, k);
    if (v) domicilio[k] = v;
  }
  return domicilio;
}
